import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setAuthToken } from '../utils/auth';

const AuthPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const jwt = searchParams.get('jwt');

  useEffect(() => {
    let target = '/';

    if (jwt) {
      setAuthToken(jwt);

      const returnToRaw = searchParams.get('return_to');
      const decodedReturnTo = returnToRaw ? decodeURIComponent(returnToRaw) : '/';
      const isSafePath = decodedReturnTo.startsWith('/');
      target = isSafePath ? decodedReturnTo : '/';
    }

    const timeoutId = window.setTimeout(() => {
      navigate(target, { replace: true });
    }, 1000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [jwt, navigate, searchParams]);

  if (!jwt) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="w-full max-w-md text-center">
          <h1 className="text-2xl font-semibold text-gray-900 mb-2">Aan het aanmelden…</h1>
          <p className="text-gray-600">Geen geldige login, ogenblik geduld terwijl we je doorsturen.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Aan het aanmelden…</h1>
        <p className="text-gray-600">Een ogenblik geduld terwijl we je doorsturen.</p>
      </div>
    </div>
  );
};

export default AuthPage;
